import { Feature } from '../../core/access';

export interface FAQ {
  question: string;
  answer: string;
}
export interface FeatureInfo {
  featureId: Feature;
  featureTitle: string;
  image?: string;
  minUpgradeLevel?: string;
  description?: string;
  upgradeButtonText?: string;
  learnMoreLink?: string;
  topPoints?: string[];
  moreInfoTitle?: string;
  moreInfoSection1Title?: string;
  moreInfoSection1Icon?: string;
  moreInfoSection1Description?: string;
  moreInfoSection1Link?: string;
  moreInfoSection2Title?: string;
  moreInfoSection2Icon?: string;
  moreInfoSection2Description?: string;
  moreInfoSection2Link?: string;
  videoLink?: string;
  faqs?: FAQ[];
}

export function getFeatureInfo(featureId: string): FeatureInfo {
  return RESTRICTED_CONTENT.filter((f) => f.featureId === featureId)[0];
}

export const RESTRICTED_CONTENT: FeatureInfo[] = [
  // Vendasta Payments
  {
    featureId: Feature.vendastaPayments,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TITLE',
    image: 'images/restricted/vendasta-payments.png',
    description: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.DESCRIPTION',
    upgradeButtonText: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.UPGRADE_BUTTON_TEXT',
    learnMoreLink: 'https://support.vendasta.com/hc/en-us/articles/4406961189271-Setting-up-Vendasta-Payments',
    topPoints: [
      'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TOP_POINTS_1',
      'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TOP_POINTS_2',
      'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TOP_POINTS_3',
      'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TOP_POINTS_4',
    ],
    moreInfoTitle: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_TITLE',
    moreInfoSection1Icon: 'receipt_long',
    moreInfoSection1Title: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_1_TITLE',
    moreInfoSection1Description: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_1_DESCRIPTION',
    moreInfoSection1Link:
      'https://support.vendasta.com/hc/en-us/articles/16683150168599-FAQs-for-Retail-Subscription-Management',
    moreInfoSection2Icon: 'repeat',
    moreInfoSection2Title: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_2_TITLE',
    moreInfoSection2Description: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_2_DESCRIPTION',
    moreInfoSection2Link: 'https://support.vendasta.com/hc/en-us/articles/4406960017815-Create-and-send-invoices',
    videoLink: '',
    faqs: [
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_1_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_1_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_2_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_2_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_3_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_3_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_4_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_4_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_5_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_5_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_6_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_6_ANSWER',
      },
    ],
  },
  // My products
  {
    featureId: Feature.myProducts,
    featureTitle: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TITLE',
    image: 'images/restricted/vendasta-payments.png',
    description: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.DESCRIPTION',
    upgradeButtonText: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.UPGRADE_BUTTON_TEXT',
    learnMoreLink: 'https://support.vendasta.com/hc/en-us/articles/4406961189271-Setting-up-Vendasta-Payments',
    topPoints: [
      'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TOP_POINTS_1',
      'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TOP_POINTS_2',
      'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TOP_POINTS_3',
      'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.TOP_POINTS_4',
    ],
    moreInfoTitle: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_TITLE',
    moreInfoSection1Icon: 'receipt_long',
    moreInfoSection1Title: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_1_TITLE',
    moreInfoSection1Description: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_1_DESCRIPTION',
    moreInfoSection1Link:
      'https://support.vendasta.com/hc/en-us/articles/16683150168599-FAQs-for-Retail-Subscription-Management',
    moreInfoSection2Icon: 'repeat',
    moreInfoSection2Title: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_2_TITLE',
    moreInfoSection2Description: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.MORE_INFO_2_DESCRIPTION',
    moreInfoSection2Link: 'https://support.vendasta.com/hc/en-us/articles/4406960017815-Create-and-send-invoices',
    videoLink: '',
    faqs: [
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_1_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_1_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_2_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_2_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_3_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_3_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_4_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_4_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_5_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_5_ANSWER',
      },
      {
        question: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_6_QUESTION',
        answer: 'RESTRICTED_FEATURE_CONTENT_V2.VENDASTA_PAYMENTS.FAQ_6_ANSWER',
      },
    ],
  },
];
